// src/pages/MyPage/MyTicketPurchased.jsx

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import confetti from "../../../assets/icons/Token/Confetti.svg";
import gallery from "../../../assets/icons/Token/Gallery.svg";
import palette from "../../../assets/icons/Token/Palette.svg";
import chart from "../../../assets/icons/Token/Pie_chart.svg";
import media from "../../../assets/icons/Token/Social_media.svg";
import { SingleButton } from "../../../assets/components/ButtonGroup";

const MyTicketPurchased = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // 이전 페이지에서 넘겨준 값들
  const token = location.state?.token_amount || 10;
  const origin = location.state?.origin || "home";
  const storeBusinessNumber = location.state?.storeBusinessNumber

  const isFromCalendar = origin === "myCalendar";
  const isFromCalendarDetail = origin === "myCalendarDetail";
  const isFromAIResult = origin === "aiResult";
  const buttonLabel = ( isFromCalendar || isFromCalendarDetail || isFromAIResult ) ? "확인" : "홈 화면으로";

  const handleButtonClick = () => {
    if (isFromCalendarDetail) {
      navigate("/mycalendar/datail", { state: {
        record: location.state?.record,
        manualData: location.state?.manualData,
        storeBusinessNumber: location.state?.storeBusinessNumber,
        from: "calendarDetail",
      }});
    }
    if (isFromAIResult) {
      navigate("/manual/marketing/ai/result", { state: location.state });
      return;
    }
    if (isFromCalendar) {
      // 캘린더에서 진입한 경우
      navigate("/mycalendar");
    } else {
      // 기본: 홈으로
      navigate("/ads/main", {
        state: {
          tab: "home",
          storeBusinessNumber
        }
      })
    }
  };

  return (
    <div className="h-dvh flex flex-col">
      {/* 가운데 본문 영역 */}
      <main className="flex-1 flex flex-col items-center justify-center px-[16px]">

        {/* 타이틀 / 서브타이틀 */}
        <div className="text-center pt-[40px]">
          <p className="text-t2 text-text-default pb-[12px]">
            구매가 완료되었어요
          </p>
          <p className="text-b1 text-text-subtler">
            다양한 기능을 사용해 보세요.
          </p>
        </div>
        {/* 축하 아이콘 */}
        <div className="py-[80px]">
          <img
            src={confetti}
            alt="구매 완료"
            className="w-[128px] h-[128px]"
          />
        </div>

        {/* 상품 */}
        <div className="text-center text-t2 text-text-primary pb-[20px]">
          토큰 {token}개 구매 완료!
        </div>

        {/* 혜택 리스트 카드 */}
        <div className="w-full rounded-[16px] bg-surface-light-subtle px-[16px] py-[12px] space-y-[8px] text-c2 text-text-subtle">
          <div className="flex items-start gap-[6px] ">
            <img src={chart} alt="chart" className="w-[20px] h-[20px] shrink-0" />
            <p>가게를 파악할 수 있는 AI Report를 제공해요</p>
          </div>

          <div className="flex items-start gap-[6px]">
            <img src={palette} alt="paint" className="w-[20px] h-[20px] shrink-0" />
            <p>50여 종의 디자인 스타일을 제공해요</p>
          </div>

          <div className="flex items-start gap-[6px]">
            <img src={gallery} alt="gallery" className="w-[20px] h-[20px] shrink-0" />
            <p>20여 종의 디자인 템플릿을 제공해요</p>
          </div>

          <div className="flex items-start gap-[6px]">
            <img src={media} alt="sns" className="w-[20px] h-[20px] shrink-0" />
            <p>SNS 마케팅 효과를 누려보세요</p>
          </div>
        </div>
      </main>

      {/* 하단 버튼 */}
      <div>
        <SingleButton onClick={handleButtonClick}>
          {buttonLabel}
        </SingleButton>
      </div>
    </div>
  );
};

export default MyTicketPurchased;
